module.exports = __webpack_public_path__ + "static/media/aivr-hybrid.cf0c4d97.svg";